import React, { Fragment } from 'react'
import { usePricing, PricingProps, PricingPlans } from './usePricing'
import styles from './Pricing.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import PricingItem from 'components/PricingItem/PricingItem'
import PricingModal from 'components/Modal/PricingModal/PricingModal'

const Pricing: React.FC<PricingProps> = (props: PricingProps) => {
  const {
    showModal,
    freePlanFeatures,
    plusPlanFeatures,
    proPlanFeatures,
    selectedPlan,
    setShowModal,
    handleSubscribeClick,
    handlePlanChange,
  } = usePricing(props)

  return (
    <Fragment>
      <section id='pricing' className={styles.pricing}>
        <TitleSection
          title='Pricing'
          descriptionTitle='Pricing'
          description='Choose the plan that fits your needs — flexible pricing for every stage of growth.'
        />

        <div className='container'>
          <div className='row gy-4 justify-content-center'>
            <div className='col-lg-4 col-md-6'>
              <PricingItem
                planName='Free Forever'
                icon='star'
                cost='0'
                description='Perfect for small restaurants to get started with a simple, branded online menu.'
                btnLabel='Subscribe Now'
                features={freePlanFeatures}
                onSubscribeClick={() =>
                  handleSubscribeClick(PricingPlans.FreePlan)
                }
              />
            </div>

            <div className='col-lg-4 col-md-6'>
              <PricingItem
                planName='Plus'
                icon='star-fill'
                cost='79'
                description='For growing restaurants that need more flexibility and full menu control.'
                btnLabel='Get Plus'
                features={plusPlanFeatures}
                isFeatured
                onSubscribeClick={() =>
                  handleSubscribeClick(PricingPlans.PlusPlan)
                }
              />
            </div>

            <div className='col-lg-4 col-md-6'>
              <PricingItem
                planName='Pro'
                icon='stars'
                cost='149'
                description='Full customization plus an AI-powered menu assistant that answers guest questions about dishes, ingredients, diets, and more.'
                btnLabel='Get Pro'
                features={proPlanFeatures}
                onSubscribeClick={() =>
                  handleSubscribeClick(PricingPlans.ProPlan)
                }
              />
            </div>
          </div>
        </div>
      </section>

      {showModal && (
        <PricingModal
          title='Choose Your Plan'
          plan={selectedPlan}
          setShowModal={setShowModal}
          handlePlanChange={handlePlanChange}
        />
      )}
    </Fragment>
  )
}

export default Pricing
